import {
  notificationRuleOptionsQuery,
  workspaceNotificationRulesQuery,
} from "@common/api/notification-rules"
import { createFileRoute } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"
import { emptyRule } from "./-components/form/schema"
import { RulePage } from "./-components/rule-page"
import { CREATE_RULES_PERMISSION } from "./-lib/permission"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/notification-rules/create",
)({
  staticData: { breadcrumb: "New rule" },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      CREATE_RULES_PERMISSION,
      "/settings/workspace/general",
    ),
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(workspaceNotificationRulesQuery()),
      queryClient.ensureQueryData(notificationRuleOptionsQuery()),
    ]),
  component: CreateRulePage,
})

function CreateRulePage(): React.ReactElement {
  return <RulePage rule={undefined} defaults={emptyRule} />
}
